import { render, staticRenderFns } from "./StclD_Details.vue?vue&type=template&id=0dc05baa"
import script from "./StclD_Details.vue?vue&type=script&lang=js"
export * from "./StclD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports